module.exports = __webpack_public_path__ + "static/media/eps3.d8f526f3.png";